"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _stores = require("@seedlang/stores");
var _utils = require("@seedlang/utils");
var _root_state = _interopRequireDefault(require("./root_state"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ForumUI = (_class = /*#__PURE__*/function (_RootState) {
  function ForumUI() {
    var _this;
    _classCallCheck(this, ForumUI);
    _this = _callSuper(this, ForumUI);
    _initializerDefineProperty(_this, "editComment", _descriptor, _this);
    _initializerDefineProperty(_this, "editForumThread", _descriptor2, _this);
    _initializerDefineProperty(_this, "title", _descriptor3, _this);
    _initializerDefineProperty(_this, "body", _descriptor4, _this);
    _initializerDefineProperty(_this, "caretPositionBody", _descriptor5, _this);
    _initializerDefineProperty(_this, "caretPositionTitle", _descriptor6, _this);
    _initializerDefineProperty(_this, "forumThreadId", _descriptor7, _this);
    _initializerDefineProperty(_this, "forumId", _descriptor8, _this);
    _initializerDefineProperty(_this, "submitting", _descriptor9, _this);
    _initializerDefineProperty(_this, "postAsUser", _descriptor0, _this);
    _initializerDefineProperty(_this, "postAsSeedlang", _descriptor1, _this);
    _initializerDefineProperty(_this, "word", _descriptor10, _this);
    _initializerDefineProperty(_this, "sentenceId", _descriptor11, _this);
    _initializerDefineProperty(_this, "sentenceTargetText", _descriptor12, _this);
    _this.loadForum = function (forumId, forceLoad) {
      if (forumId) {
        _this.forumId = forumId;
      }
      if (forceLoad || !_this.forumStore.hasShowData || _this.forumStore.showData.id !== _this.forumId) {
        _this.forumStore.getShow({
          queryStrings: {
            without_comments: true
          },
          ids: {
            forumId: _this.forumId
          }
        });
      }
    };
    _this.loadForumThread = function (forumThreadId) {
      if (forumThreadId) {
        _this.forumThreadId = forumThreadId;
      }
      if (_this.forumThreadId) {
        _this.forumThreadStore.getShow({
          queryStrings: {
            without_comments: true
          },
          ids: {
            forumThreadId: _this.forumThreadId
          }
        });
      }
    };
    _this.toggleEditForumThread = function () {
      if (_this.editForumThread) {
        _this.body = null;
        _this.title = null;
      } else {
        _this.body = _this.forumThread.body;
        _this.title = _this.forumThread.title;
      }
      _this.editForumThread = !_this.editForumThread;
    };
    _this.onSetWord = function (word) {
      _this.word = word;
    };
    _this.onDestroyThread = function () {
      _this.forumThreadStore.destroy({
        ids: {
          forumThreadId: _this.forumThread.id
        }
      }, _this.afterDestroyForumThread);
    };
    _this.afterDestroyForumThread = function () {
      _this.routeStore.routeToNamed('forums.show', {
        page: 1,
        forumId: _this.forumId
      });
    };
    _this.onTogglePinned = function () {
      _this.forumThreadStore.update({
        ids: {
          forumThreadId: _this.forumThread.id
        },
        data: {
          pinned: !_this.forumThread.pinned
        }
      }, function () {
        return _this.loadForumThread();
      });
    };
    _this.onToggleSeenByAdmin = function () {
      if (AppUI.siteIsSeedlang) return;
      var newValue = !_this.forumThread.seenByAdmin;
      _this.forumThread.set('seenByAdmin', newValue);
      _this.forumThreadStore.update({
        ids: {
          forumThreadId: _this.forumThread.id
        },
        data: {
          seen_by_admin: newValue
        }
      }, function () {
        _this.loadForumThread();
        _this.loadForum(_this.forumId, true);
      });
    };
    _this.onSetTag = function (tag) {
      var ary = _this.forumThreadStore.showData.tag ? _this.forumThreadStore.showData.tag.split(',') : [];
      if (ary.includes(tag)) {
        ary = ary.filter(function (item) {
          return item !== tag;
        });
      } else {
        ary.push(tag);
      }
      _this.forumThread.set('tag', ary.join(','));
      _this.forumThreadStore.update({
        ids: {
          forumThreadId: _this.forumThread.id
        },
        data: {
          tag: ary.join(',')
        }
      }, function () {
        return _this.loadForumThread();
      });
    };
    _this.onCreateForumThread = function (forumId, groupId, languageId) {
      _this.groupId = groupId;
      _this.languageId = languageId;
      var callback;
      if (groupId) {
        callback = _this.onAfterCreateForumThreadRedirectClassroom;
      } else if (languageId) {
        callback = _this.onAfterCreateForumThreadRedirectTranslator;
      } else {
        callback = _this.onAfterCreateForumThreadRedirectForum;
      }
      if (forumId) {
        _this.forumId = forumId;
      }
      var userId;
      if (!_this.postAsSeedlang) {
        userId = _this.postAsUser && _this.postAsUser.id ? _this.postAsUser.id : _this.user.id;
      }
      if (_this.editForumThread) {
        _this.forumThreadStore.update({
          ids: {
            forumThreadId: _this.forumThread.id
          },
          data: {
            body: _this.body,
            title: _this.title
          }
        }, _this.onAfterUpdateForumThread.bind(_this));
      } else if (!_this.disabled) {
        _this.forumThreadStore.create({
          data: {
            user_id: userId,
            word_id: _this.word && _this.word.id,
            sentence_id: _this.sentenceId,
            body: _this.body,
            title: _this.word || _this.sentenceId ? null : _this.title,
            forumId: forumId
          }
        }, callback);
      }
    };
    _this.onCreateComment = function (params, callback) {
      if (!_this.submitting) {
        _this.submitting = true;
        if (_this.editComment) {
          _this.commentStore.update({
            ids: {
              commentId: _this.editComment.id
            },
            data: {
              text: params.text,
              updated: true
            }
          }, callback || _this.onAfterCreateComment.bind(_this));
        } else {
          _this.commentStore.create({
            data: {
              text: params.text,
              user_id: _this.user.id,
              commentable_id: params.commentableId,
              parent_id: params.parentId,
              word_id: params.wordId,
              sentence_id: params.sentenceId,
              concept_id: params.conceptId,
              faq_item_id: params.faqItemId,
              commentable_type: params.commentableType,
              debug_info: params.debugInfo,
              comment_type: 'response',
              xp: 2,
              xp_slug: 'comment'
            }
          }, callback || _this.onAfterCreateComment.bind(_this));
        }
      }
    };
    _this.onAfterCreateComment = function (resp) {
      _this.submitting = false;
      _this.editComment = null;
      _this.loadForumThread(resp.commentableId);
      _this.onResetPost();
    };
    _this.onAfterCreateForumThreadRedirectForum = function (resp) {
      _this.routeStore.routeToNamed('forums.forum_threads.show', {
        forumId: _this.forumId,
        forumThreadId: resp.id
      });
      _this.onReset();
    };
    _this.onAfterCreateForumThreadRedirectTranslator = function (resp) {
      _this.routeStore.routeToNamed('translator.home', {
        languageId: _this.languageId,
        forumThreadId: resp.id
      });
      _this.onReset();
    };
    _this.onAfterCreateForumThreadRedirectClassroom = function (resp) {
      _this.routeStore.routeToNamed('classroom.forum_threads.show', {
        groupId: _this.groupId,
        forumThreadId: resp.id
      });
      _this.onReset();
    };
    _this.onAfterUpdateForumThread = function () {
      _this.submitting = false;
      _this.loadForumThread(_this.forumThread.id);
      _this.onReset();
    };
    _this.onReset = function () {
      _this.word = null;
      _this.sentenceId = null;
      _this.sentenceTargetText = null;
      _this.editForumThread = false;
      _this.postAsUser = null;
      _this.editComment = null;
      _this.submitting = false;
      _this.body = '';
      _this.title = '';
      _this.caretPositionBody = null;
      _this.caretPositionTitle = null;
      _this.forumThreadId = null;
    };
    _this.onResetPost = function () {
      _this.body = '';
    };
    _this.cancelEditComment = function () {
      _this.editComment = null;
      _this.body = null;
    };
    _this.onChangeBody = function (value) {
      var el = document.getElementById('forum-body');
      _this.body = value;
      if (el) {
        _this.caretPositionBody = el.selectionStart;
      }
    };
    _this.onChangeTitle = function (value) {
      var el = document.getElementById('forum-title');
      _this.title = value;
      if (el) {
        _this.caretPositionTitle = el.selectionStart;
      }
    };
    _this.insertBodyText = function (text) {
      var el = document.getElementById('forum-body');
      if (el) {
        var caretPositionBody = el.selectionStart;
        var newValue = [_this.body.slice(0, caretPositionBody), text, _this.body.slice(caretPositionBody)].join('');
        _this.caretPositionBody = caretPositionBody + 1;
        _this.body = newValue;
      }
    };
    _this.insertTitleText = function (text) {
      var el = document.getElementById('forum-title');
      var caretPositionTitle = el.selectionStart;
      var newValue = [_this.title.slice(0, caretPositionTitle), text, _this.title.slice(caretPositionTitle)].join('');
      _this.caretPositionTitle = caretPositionTitle + 1;
      _this.title = newValue;
    };
    _this.setEditComment = function (comment) {
      _this.editComment = comment;
    };
    _this.authUserStore = _stores.AuthUserStore;
    _this.forumStore = _stores.ForumStore;
    _this.forumThreadStore = _stores.ForumThreadStore;
    _this.routeStore = _stores.RouteStore;
    _this.commentStore = _stores.CommentStore;
    _this.feedbackStore = _stores.FeedbackStore;
    _this.userStore = _stores.UserStore;
    return _this;
  }
  _inherits(ForumUI, _RootState);
  return _createClass(ForumUI, [{
    key: "user",
    get: function get() {
      return this.authUserStore.showData;
    }
  }, {
    key: "userIsLoaded",
    get: function get() {
      return (0, _utils.isPresent)(this.user.id);
    }
  }, {
    key: "hasForumThread",
    get: function get() {
      return this.forumThreadStore.hasShowData;
    }
  }, {
    key: "dropInForumThread",
    get: function get() {
      return (0, _utils.isPresent)(this.forumThread.referralRoute);
    }
  }, {
    key: "hasForum",
    get: function get() {
      return this.forumStore.hasShowData;
    }
  }, {
    key: "forum",
    get: function get() {
      return this.forumStore.showData;
    }
  }, {
    key: "forumThread",
    get: function get() {
      return this.forumThreadStore.showData;
    }
  }, {
    key: "disabledForumThread",
    get: function get() {
      return this.submitting || ((0, _utils.isBlank)(this.body) || (0, _utils.isBlank)(this.title)) && (0, _utils.isBlank)(this.sentenceId) && (0, _utils.isBlank)(this.word);
    }
  }]);
}(_root_state["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "editComment", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "editForumThread", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "title", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "body", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "caretPositionBody", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "caretPositionTitle", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "forumThreadId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "forumId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "submitting", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "postAsUser", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "postAsSeedlang", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "word", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "sentenceId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "sentenceTargetText", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "user", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "user"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userIsLoaded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userIsLoaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasForumThread", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasForumThread"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dropInForumThread", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "dropInForumThread"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasForum", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasForum"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "forum", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "forum"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "forumThread", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "forumThread"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disabledForumThread", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "disabledForumThread"), _class.prototype), _class);
var _default = exports["default"] = new ForumUI();